.page {
  --auth-accent: var(--evolys-brand-primary);
  min-height: 100vh;
  background:
    linear-gradient(
      90deg,
      color-mix(in srgb, var(--auth-accent) 7%, transparent) 1px,
      transparent 1px
    ),
    light-dark(#f4faf8, #0e1514);
  background-size: 5rem 100%;
}

.topbar {
  position: fixed;
  z-index: 3;
  top: 0;
  right: 0;
  left: 0;
  height: 4.5rem;
  border-bottom: 1px solid light-dark(#dce9e6, #263633);
  background: light-dark(
    rgba(255, 255, 255, 0.88),
    rgba(15, 22, 21, 0.9)
  );
  backdrop-filter: blur(16px);
}

.brandMark {
  color: var(--auth-accent);
  background: color-mix(
    in srgb,
    var(--auth-accent) 11%,
    transparent
  );
}

.content {
  display: grid;
  width: min(1180px, calc(100% - 2rem));
  min-height: 100vh;
  margin-inline: auto;
  grid-template-columns: minmax(0, 1.15fr) minmax(22rem, 0.85fr);
  gap: clamp(2rem, 6vw, 6rem);
  align-items: center;
  padding-block: 7rem 3rem;
}

.story {
  position: relative;
  min-height: 30rem;
  display: flex;
  align-items: center;
  overflow: hidden;
  padding: clamp(2rem, 5vw, 4rem);
  border: 1px solid
    color-mix(in srgb, var(--auth-accent) 30%, transparent);
  border-radius: 1.5rem;
  background: light-dark(rgba(255, 255, 255, 0.82), #16201e);
  box-shadow: 0 28px 80px
    color-mix(in srgb, var(--auth-accent) 12%, transparent);
}

.story::before {
  position: absolute;
  top: -7.5rem;
  right: -6rem;
  width: 23rem;
  height: 23rem;
  border: 3.4rem solid
    color-mix(in srgb, var(--auth-accent) 10%, transparent);
  border-radius: 50%;
  box-shadow:
    0 0 0 1.8rem
      color-mix(in srgb, var(--auth-accent) 5%, transparent),
    inset 0 0 0 1px
      color-mix(in srgb, var(--auth-accent) 18%, transparent);
  content: "";
}

.storyCopy {
  position: relative;
  z-index: 1;
}

.eyebrow {
  color: var(--auth-accent);
  font-family: ui-monospace, "SFMono-Regular", Consolas, monospace;
  font-size: 0.72rem;
  font-weight: 750;
  letter-spacing: 0.13em;
  text-transform: uppercase;
}

.title {
  max-width: 40rem;
  color: light-dark(#10292a, #eff9f6);
  font-family: "Aptos Display", Inter, system-ui, sans-serif;
  font-size: clamp(2.5rem, 6vw, 5rem);
  font-weight: 680;
  letter-spacing: -0.055em;
  line-height: 0.94;
}

.index {
  margin-top: 1.25rem;
  padding-top: 1.25rem;
  border-top: 1px solid
    color-mix(in srgb, var(--auth-accent) 22%, transparent);
}

.indexItem {
  display: flex;
  gap: 0.55rem;
  align-items: center;
}

.indexMarker {
  width: 0.5rem;
  height: 0.5rem;
  border-radius: 50%;
  background: var(--auth-accent);
  box-shadow: 0 0 0 4px
    color-mix(in srgb, var(--auth-accent) 12%, transparent);
}

.panel {
  border: 1px solid light-dark(#d8e5e2, #2a3a37);
  background: light-dark(rgba(255, 255, 255, 0.94), #17201f);
  box-shadow: 0 24px 65px rgba(9, 42, 38, 0.12);
}

.panelCode {
  color: var(--auth-accent);
  font-family: ui-monospace, "SFMono-Regular", Consolas, monospace;
  font-size: 0.68rem;
  font-weight: 750;
  letter-spacing: 0.1em;
}

@media (max-width: 62em) {
  .content {
    grid-template-columns: 1fr;
    gap: 1.5rem;
    padding-top: 6rem;
  }

  .story {
    min-height: auto;
    padding: 2rem;
  }

  .story::before {
    top: -11rem;
    right: -10rem;
  }
}

@media (max-width: 36em) {
  .content {
    width: min(100% - 1rem, 32rem);
  }

  .story {
    display: none;
  }
}
